export default {
  init() {
    // Map rendering

    function extractFromAdress(components, type){
      for (var i=0; i<components.length; i++)
        for (var j=0; j<components[i].types.length; j++)
          if (components[i].types[j]==type) return components[i].long_name;
      return "";
    }

    // todo: https://developers.google.com/maps/documentation/javascript/examples/map-geolocation?hl=de


    var mapsAPI = 'https://maps.googleapis.com/maps/api/geocode/';
    var APIKey = 'AIzaSyBQK6qhqdIDSMYuIo7xKfDeaDLIUTHE6Pc';

    // json?latlng=
    function initMap() {
      map = new google.maps.Map(document.getElementById('map-main'), {
        center: {lat: -34.397, lng: 150.644},
        zoom: 10,
        styles: map_styles
      });
      var infoWindow = new google.maps.InfoWindow({map: map});

      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          var url = mapsAPI + 'json?latlng=' + position.coords.latitude + ', ' + position.coords.longitude + '&key=' + APIKey + '&postal_code=postal_code';

          $.getJSON(url, function(data){
            // https://maps.googleapis.com/maps/api/distancematrix/json?origins=4020&destinations=4040
            // console.log('initial data: ', data);
            var postCode = extractFromAdress(data.results[0].address_components, "postal_code");
            // console.log(postCode);

            $.ajax({
              url: hochrather.ajaxurl,
              type: 'post',
              data: {
                action: 'ajax_contact',
                zipCode: postCode
              },
              success: function( result ) {
                // console.log('result empty? ',  result == '');
                if(result != ''){
                  $('.js-dynamic-contact').html(result);
                }
              }
            });
          });

          infoWindow.setPosition(pos);
          infoWindow.setContent('Hier ist ihr Standort.');
          map.setCenter(pos);
        }, function() {
          handleLocationError(true, infoWindow, map.getCenter());
        });
      } else {
        // Browser doesn't support Geolocation
        handleLocationError(false, infoWindow, map.getCenter());
      }
    }

    function handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(browserHasGeolocation ?
        'Error: The Geolocation service failed.' :
        'Error: Your browser doesn\'t support geolocation.');
    }

    var map_styles = [
      {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "lightness": 65
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "lightness": "50"
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "-100"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "30"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
          {
            "lightness": "40"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "saturation": -100
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "hue": "#ffff00"
          },
          {
            "lightness": -25
          },
          {
            "saturation": -97
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
          {
            "lightness": -25
          },
          {
            "saturation": -100
          }
        ]
      }
    ];


    function new_map( $el ) {
      var $markers = $el.find('.marker');
      var $markerUser = $el.find('.marker-user');

      var args = {
        zoom: 22,
        center: new google.maps.LatLng(0, 0),
        mapTypeControl: false,
        panControl: false,
        scrollwheel: false,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        styles: map_styles
      };

      map = new google.maps.Map( $el[0], args);

      map.markers = [];

      $markers.each(function(){
        add_marker( $(this), map );
      });

      $markerUser.each(function(){
        add_user_marker( $(this), map );
      });

      center_map( map );


      return map;
    }

    function add_user_marker($marker, map){
      // todo: check if https - geocode location etc. -> query correct contact-person
      if ("geolocation" in navigator) {
        /* geolocation funktioniert */
        navigator.geolocation.getCurrentPosition(function(position){
          var latlng = new google.maps.LatLng( position.coords.latitude, position.coords.longitude );
          var marker = new google.maps.Marker({
            position	: latlng,
            map			: map,
            title       : 'Ihr Standort',
            icon        : '/wp-content/uploads/poi.png'
          });

          var url = mapsAPI + 'json?latlng=' + position.coords.latitude + ', ' + position.coords.longitude + '&key=' + APIKey + '&postal_code=postal_code';

          $.getJSON(url, function(data){
            // console.log('initial data: ', data);
            var postCode = extractFromAdress(data.results[0].address_components, "postal_code");
            // console.log(postCode);

            $.ajax({
              url: hochrather.ajaxurl,
              type: 'post',
              data: {
                action: 'ajax_contact',
                zipCode: postCode
              },
              success: function( result ) {
                if(result != ''){
                  $('.js-dynamic-contact').html(result);
                }
              }
            });
          });

          map.markers = [];

          map.markers.push( marker );
          // console.log(map);
          center_map(map);

          if( $marker.html() ) {
            var infowindow = new google.maps.InfoWindow({
              content: $marker.html(),
              center: latlng,
              position: latlng
            });

            google.maps.event.addListener(marker, 'click', function() {
              infowindow.open( map, marker );
            });
          }
        });
      }
    }

    function add_marker( $marker, map ) {
      // console.log('$marker.attr(\'data-lat\')', typeof($marker.attr('data-lat')), $marker.attr('data-lat'))
      var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

      var marker = new google.maps.Marker({
        position	: latlng,
        map			: map,
        title       : 'Hochrather',
        icon        : '/wp-content/uploads/poi.png'
      });

      map.markers.push( marker );

      if( $marker.html() ) {
        var infowindow = new google.maps.InfoWindow({
          content		: $marker.html()
        });

        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open( map, marker );
        });
      }

      center_map(map);
    }

    function center_map( map ) {
      var bounds = new google.maps.LatLngBounds();

      $.each( map.markers, function( i, marker ){
        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
        bounds.extend( latlng );
      });

      if( map.markers.length == 1 ) {
        map.setCenter( bounds.getCenter() );
        map.setZoom( 16 );
      } else {
        map.fitBounds( bounds );
      }
    }
    jQuery(document).ready(function($) {
      // Generate map
      if($('#map-main').length > 0){
        initMap();
      }else{
        $('.acf-map').each(function(){
          map = new_map( $(this) );
        });
      }
    });
    //
    var map = null;
  }
}


// WEBPACK FOOTER //
// ./scripts/routes/standorte.js